// src/components/PrivateRoute.tsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface PrivateRouteProps {
  children: React.ReactNode;
  requiredRole?: 'Admin' | 'Moderator' | 'Contractor' | Array<'Admin' | 'Moderator' | 'Contractor'>;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, requiredRole }) => {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return <p>Loading authentication...</p>;
  }

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRole) {
    const roles = Array.isArray(requiredRole) ? requiredRole : [requiredRole];
    const hasRole = roles.some(role => {
      if (role === 'Admin') return currentUser.isAdmin;
      if (role === 'Moderator') return currentUser.isModerator;
      if (role === 'Contractor') return currentUser.isContractor;
      return false;
    });
    if (!hasRole) return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
